// src/services/ContactosService.js

const API = "/api/contactos";

export const obtenerContactos = async () => {
  const res = await fetch(API);
  return await res.json();
};

export const crearContacto = async (data) => {
  const res = await fetch(API, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data)
  });

  return await res.json();
};

export const eliminarContacto = async (id) => {
  const res = await fetch(`${API}?id=${id}`, {
    method: "DELETE"
  });

  return await res.json();
};
